import { ofType } from "redux-observable";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
import { checkTutorialConstructConfirmPlacement } from "../checks/checkTutorialConstructConfirmPlacement";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { pathTutorialUpdate } from "../path/pathTutorialUpdate";
export var epicTutorialConstructConfirmPlacement = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionBuildings.StartPurchase), guard(state$, deps, pathEmpty)([
        combineChecks([
            checkTutorialNextStepConfigExists,
            checkTutorialConstructConfirmPlacement,
        ])(pathTutorialUpdate),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialConstructConfirmPlacement.ts
// module id = 2462
// module chunks = 3